// extracted by mini-css-extract-plugin
export default {"dashboard":"Dashboard_dashboard__CM5BJ","sidebar":"Dashboard_sidebar__uD4kY","logout":"Dashboard_logout__y3sjc","content":"Dashboard_content__7O-V9"};